export const APP_VERSION = {
  version: '1.1.0',
  buildDate: new Date().toISOString(),
  buildNumber: new Date().getTime()
}
